import { render } from "./Config.vue?vue&type=template&id=3a899dbb"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
script.render = render

export default script